import { Injectable } from '@angular/core';
import { gql } from 'graphql-tag';
import { BehaviorSubject } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { AuthenticationService } from '../authentication/authentication.service';
import { GetOperatorQuery } from '../telemetry/index.graph-ql';
import { maybeSwitchMap } from '../utils';
import { Operator } from '../telemetry'
import { StateService } from '../state/state.service';
import { OperatorData } from '../models/firebase.model';

const OperatorQuery = gql`
  fragment operator on Operator {
    active
    email
  }
`;

const companyName = 'ZCS';

@Injectable({
  providedIn: 'root',
})
export class OperatorService {
  readonly isOperator$ = new BehaviorSubject<boolean>(false);
  readonly operatorData$ = new BehaviorSubject<OperatorData>({});

  /** @abstract if undefined -> isn't operator */
  readonly operator$ = new BehaviorSubject<Partial<Operator> | undefined | null>(null);

  private readonly _isOperator = this.authenticationService.user$.pipe(
    map((user) => user?.email),
    maybeSwitchMap((email) => this.getOperatorQuery.execute(OperatorQuery, { email, companyName })),
    map((operator) => operator?.data.getOperator as Partial<Operator>[]),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  constructor(
    private readonly authenticationService: AuthenticationService,
    private readonly getOperatorQuery: GetOperatorQuery,
    private readonly stateService: StateService,
  ) {
    this.stateService.data$.subscribe((data) => this.operatorData$.next(data?.operator || {}));

    this._isOperator.subscribe((operators) => {
      const operator = operators && operators.pop();
      this.isOperator$.next(!!operator?.active);
      this.operator$.next(operator);
    });
  }
}
